
























import { defineComponent, PropType } from '@vue/composition-api';
import type { MenuMode } from '@/models/runCourse';

export default defineComponent({
  props: {
    menuMode: {
      type: String as PropType<MenuMode>,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    menuStyle: {
      type: Object as PropType<Record<string, string>>,
      default: () => ({}),
    },
  },
  emits: ['create', 'separate', 'combine'],
});
